import { watch, type Ref } from 'vue'
import { IMPACT_OF_DISABILITY_EVENT_NAMES } from '../event_names'
import type { ImpactArea } from '../impact-of-disability_types'

type SendEvent = (eventName: string, eventData: Record<string, unknown>) => void

type Selections = {
  subjects: Ref<string[]>
  impactAreas: Ref<ImpactArea[]>
}

export function useSelectionChangeEvents(sendEvent: SendEvent, { subjects, impactAreas }: Selections) {
  watch(subjects, (newVal, oldVal) => {
    if (newVal.length > oldVal.length) {
      const addedVal = newVal.find(subj => !oldVal.includes(subj))
      if (addedVal) {
        sendEvent(IMPACT_OF_DISABILITY_EVENT_NAMES.SELECTED_SUBJECT, { iod_selected_subject: addedVal })
      }
    } else {
      const removedVal = oldVal.find(subj => !newVal.includes(subj))
      if (removedVal) {
        sendEvent(IMPACT_OF_DISABILITY_EVENT_NAMES.REMOVED_SUBJECT, { iod_removed_subject: removedVal })
      }
    }
  })

  watch(impactAreas, (newVal, oldVal) => {
    if (newVal.length > oldVal.length) {
      const addedVal = newVal.find(subj => oldVal.every(oldSubj => subj.area_uuid !== oldSubj.area_uuid))
      if (addedVal) {
        sendEvent(IMPACT_OF_DISABILITY_EVENT_NAMES.SELECTED_IMPACT_AREA, { iod_selected_impact_area: addedVal.area_label })
      }
    } else if (oldVal.length) {
      const removedVal = oldVal.find(subj => newVal.every(newSubj => subj.area_uuid !== newSubj.area_uuid))
      if (removedVal) {
        sendEvent(IMPACT_OF_DISABILITY_EVENT_NAMES.REMOVED_IMPACT_AREA, { iod_removed_impact_area: removedVal.area_label })
      }
    }
  })
}
